import ActivityModule from './activity.module'

export default ActivityModule
